import React from "react";
import styles from "./FirstBox.module.css";
import CtaButton from "./CtaButton/CtaButton";

const FirstBox = () => {
  return (
    <div className="eachpage first">
      <div className="container-on-box">
        <div className={styles.coolstuf}>COOL STUFF</div>
        <div className={styles.littleline}></div>
        <div className={styles.workdesc}>
          ایجاد رابط کاربری جذاب و متفاوت بر اساس دیزاین محل کسب و کار و لوگوی
          شما از تخصص ماست
        </div>
        <div className={styles.containbuttons}>
          <a href="tel:+989027831161"><CtaButton cta={true}>مشاوره رایگان</CtaButton></a>
        </div>
      </div>
    </div>
  );
};

export default FirstBox;
